module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/5@2x_c41c397444a58b7c1f318eb807d67d92.png";